import { AlertTriangle } from "lucide-react";

export default function ConfirmDialog({ type, title, onConfirm, onCancel }) {
  const isDelete = type === "delete";

  return (
    <div
      className="fixed inset-0 modal-overlay flex items-center justify-center p-4 z-50"
      onClick={onCancel}
    >
      <div
        className="bg-cinema-card border border-cinema-border rounded-2xl shadow-2xl w-full max-w-sm p-6 animate-slide-up"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="text-center">
          <div
            className={`inline-flex items-center justify-center w-14 h-14 rounded-full mb-4 ${isDelete ? "bg-red-900/30" : "bg-emerald-900/30"}`}
          >
            <AlertTriangle
              size={28}
              className={isDelete ? "text-red-400" : "text-emerald-400"}
            />
          </div>
          <h3 className="text-lg font-bold text-white mb-2">
            {isDelete ? "¿Eliminar?" : "¿Marcar como vista?"}
          </h3>
          <p className="text-steel-300 text-sm mb-6">
            {isDelete ? (
              <>
                <strong className="text-white">{title}</strong> se eliminará
                permanentemente.
              </>
            ) : (
              <>
                <strong className="text-white">{title}</strong> se moverá a
                vistas.
              </>
            )}
          </p>
          <div className="flex gap-3">
            <button
              onClick={onCancel}
              className="flex-1 bg-steel-700 hover:bg-steel-600 text-white font-medium py-2.5 rounded-xl transition-all text-sm"
            >
              Cancelar
            </button>
            <button
              onClick={onConfirm}
              className={`flex-1 font-medium py-2.5 rounded-xl transition-all text-sm text-white ${isDelete ? "bg-red-600 hover:bg-red-500" : "bg-emerald-600 hover:bg-emerald-500"}`}
            >
              {isDelete ? "Eliminar" : "Confirmar"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
